import React from "react";
import { useNavigate } from "react-router-dom";

const RecommendationCard = ({ name, company, industry, image, id, viewType = "pending", recommendationId }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (viewType === "recent") {
      navigate(`/bosses?bossId=${id}`);
    } else {
      navigate(`/pending_requests?recommendationId=${recommendationId || id}`);
    }
  };

  const buttonLabel = viewType === "recent" ? "View Details" : "Read Recommendation";

  return (
    <div style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "clamp(6px, 1.5vw, 10px)", // Reduced padding for tighter spacing
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      gap: "clamp(8px, 2vw, 12px)",
      '@media (max-width: 480px)': {
        flexDirection: 'column',
        alignItems: 'flex-start'
      }
    }}>
      <div style={{ 
        display: "flex", 
        alignItems: "center",
        gap: "clamp(8px, 2vw, 12px)",
        minWidth: 0,
        flex: 1
      }}>
        <div style={{
          minWidth: 0,
          flex: 1
        }}>
          <div style={{ 
            fontWeight: "600",
            fontSize: "clamp(13px, 2vw, 14px)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: "1.3"
          }}>{name}</div>
          <div style={{ 
            fontSize: "clamp(12px, 1.8vw, 13px)", 
            color: "#555",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: "1.3" // Tighter line height
          }}>{company}</div>
          <div style={{ 
            fontSize: "clamp(11px, 1.6vw, 12px)", 
            color: "#999",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: "1.3" // Tighter line height
          }}>{industry}</div>
        </div>
      </div>
      <button
        style={{
          border: "1px solid #12188A",
          color: "#12188A",
          borderRadius: "20px",
          padding: "clamp(4px, 1.5vw, 6px) clamp(8px, 2vw, 12px)",
          fontSize: "clamp(12px, 1.8vw, 13px)",
          fontWeight: "500",
          backgroundColor: "#EDEEFF",
          cursor: "pointer",
          fontFamily: "Urbanist",
          whiteSpace: "nowrap",
          flexShrink: 0,
          transition: "all 0.2s ease-in-out",
          '@media (max-width: 480px)': {
            width: '100%',
            textAlign: 'center'
          },
          '&:hover': {
            backgroundColor: "#12188A",
            color: "#ffffff"
          }
        }}
        onClick={handleClick}
      >
        {buttonLabel}
      </button>
    </div>
  );
};

export default RecommendationCard;